export interface Endpoint {
  path: string;
  method: string;
}

const isSingleResourcePath = (path: string) => /\/\{[^/]+\}$/.test(path);

/**
 * Pick the endpoint used to delete one table row.
 * Some schemas list a bulk delete on the collection path (e.g. DELETE /loot?loot_ids=...) next to the single-resource
 * delete (DELETE /loot/{loot_id}), so prefer the delete whose path ends in "/{id}". Pages with no delete endpoint fall
 * back to the first get/put path with the method switched to delete.
 */
export const findDeleteEndpoint = (endpoints: Endpoint[] = []): Endpoint | undefined => {
  const deleteEndpoints = endpoints.filter((e) => e.method === "delete");
  const deleteEndpoint = deleteEndpoints.find((e) => isSingleResourcePath(e.path)) || deleteEndpoints[0];
  if (deleteEndpoint) return deleteEndpoint;

  const getEndpoint = endpoints.find((e) => e.method === "get" || e.method === "put");
  return getEndpoint ? { ...getEndpoint, method: "delete" } : undefined;
};
